import type { DailyParticipant } from '@daily-co/daily-js';

export const isDialOutParticipant = (
  participant: DailyParticipant | null | undefined,
): boolean =>
  participant?.participantType === 'pstn-dial-out' ||
  participant?.participantType === 'sip-dial-out';
